import React from "react";
import { Box, Button, FormControl, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";

const CreateLicenseModal = (props) => {
  const {
    name, totalLicenses, status, expirationDate, usedLicenses, domainName,
    openModal, handleCloseModal, setTotalLicenses, setStatus, setExpirationDate, handleSave
} = props;

  const handleExpirationDateChange = (e) => {
      const selectedDate = e.target.value;
      const timestamp = new Date(selectedDate).getTime();
      setExpirationDate(timestamp);
  };

  return (
      <Modal open={openModal} onClose={handleCloseModal}>
          <Box
              style={{
                  padding: '32px 0px !important', borderRadius: '4px', position: "absolute",
                  top: "50%", left: "50%", transform: "translate(-50%, -50%)", background: "white",
                  boxShadow: 24, p: 4, width: 700
              }}
          >
              <Typography
                  id="edit-license-modal"
                  variant="h6"
                  component="h2"
                  gutterBottom
                  sx={{ fontWeight: '600', borderBottom: 1, borderColor: "divider", padding: '20px 32px' }}
              >
                  Edit Customer
              </Typography>
              <Box sx={{padding: '20px 32px 32px 32px', display: 'flex', flexDirection: 'column'}}>
              <Box sx={{display: 'flex', flexDirection: 'column', gap: '10px', overflowY: 'auto', height: '54vh'}}>
                  <TextField
                      label="Customer Name"
                      variant="outlined"
                      fullWidth
                      value={name}
                      disabled
                      sx={{ marginBottom: "16px", marginTop: '6px' }}
                  />
                  <TextField
                    label="Domain Name"
                    variant="outlined"
                    fullWidth
                    value={domainName}
                    disabled
                    sx={{ marginBottom: "16px", marginTop: '6px' }}
                 />
                  <TextField
                      label="Allowed License"
                      variant="outlined"
                      fullWidth
                      type="number"
                      value={totalLicenses}
                      onChange={(e) => {
                            const value = e.target.value;
                            if (value === '' || (Number(value) >= (usedLicenses || 0) && !isNaN(value))) {
                                setTotalLicenses(value);
                            }
                      }}
                      inputProps={{ min: usedLicenses || 0 }}
                      helperText={`Minimum allowed: ${usedLicenses || 0} (currently used licenses)`}
                      sx={{ marginBottom: "16px", marginTop: '6px' }}
                  />
                  <FormControl fullWidth sx={{ marginBottom: "16px", marginTop: '6px' }}>
                    <InputLabel label="Status">Status</InputLabel>
                    <Select label="Status"  value={status} onChange={(e) => setStatus(e.target.value)}>
                      <MenuItem value="Active">Active</MenuItem>
                      <MenuItem value="Suspended">Suspended</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    label="Expiry Date"
                    variant="outlined"
                    type="date"
                    fullWidth
                    value={expirationDate ? new Date(expirationDate).toISOString().split("T")[0] : ""}
                    onChange={handleExpirationDateChange}
                    onClick={(e) => e.target.showPicker && e.target.showPicker()}
                    inputProps={{ min: new Date().toISOString().split("T")[0] }}
                    sx={{ 
                        marginBottom: "16px", marginTop: '6px',
                        "& .MuiInputBase-input": { cursor: "pointer" },
                        "& .MuiInputBase-root": { cursor: "pointer" },
                        "& input[type='date']::-webkit-calendar-picker-indicator": { cursor: "pointer" }
                    }}
                    InputLabelProps={{ shrink: true }}
                    />
                </Box>
                  <Box sx={{ display: "flex", justifyContent: "center", gap: "16px" }}>
                      <Button
                          variant="contained"
                          onClick={handleSave}
                          sx={{ textTransform: 'capitalize', fontWeight: '600' }}
                      >
                          Save
                      </Button>
                      <Button
                          variant="outlined"
                          onClick={handleCloseModal}
                          sx={{ textTransform: 'capitalize', fontWeight: '600' }}
                      >
                          Cancel
                      </Button>
                  </Box>
              </Box>
          </Box>
      </Modal>
  );
};

export default CreateLicenseModal;